import React from 'react';
import SizeCard from '../../../components/Molecules/Card/SizeCard/SizeCard';
import * as CONSTANT from '../../../constants';
import { IItemSizeCard } from '../../../models/order';
import styleClasses from "../../../containers/order/order.module.scss";
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { itemSizeForDesktop, itemSizeForMobile } from '../../utils';
import { useLocation } from 'react-router';
import { useIsDesignV2 } from '../../../hooks/useIsDesignV2';

const ItemSizeCard:React.FC<IItemSizeCard> = (props) => {
    const {getItemTotalCalories, item, getItemTotal, order, handleItemSizeChange, handleRedeemSize, reward_size} = props;
    const isItMobile = useCheckMobileScreen();
    const location = useLocation();
    const isDesignV2 = useIsDesignV2();

  return (
    <React.Fragment>
      {!isDesignV2 && <div className={styleClasses.select_size_box}>
        <h5 className="sub_title2 d-flex align-items-center justify-content-between f-sm-s16 f-s25 mb-2 mb-md-3">
          Select Size
          <span className="caption fs-14">Required</span>
        </h5>
      </div>}
      <div
        className={`${styleClasses.items_selector} d-flex mb-3 mb-sm-4 ${styleClasses.item_size_selector}`}
        data-testid="size-selection"
      >
        {item.half_brink_item_id && (
          <SizeCard
            title={isItMobile ?  itemSizeForMobile('HALF', item?.category_name, item?.category_id) : itemSizeForDesktop('HALF',item?.category_name, item?.category_id)}
            id={isItMobile ? CONSTANT.HALF_SIZE.title_case : CONSTANT.HALF_SIZE.upper_case}
            calories={getItemTotalCalories(item.calories || 0)}
            price={getItemTotal(item, order, item.half_brink_item_price, CONSTANT.HALF_SIZE.id)}
            additionalPrice={order?.display_price}
            onChange={handleItemSizeChange}
            selected={order.size === CONSTANT.HALF_SIZE.id || reward_size?.toUpperCase() === CONSTANT.HALF_SIZE.id}
            handleRedeemSize={handleRedeemSize}
            disabled={Boolean(reward_size && reward_size?.toUpperCase() !== CONSTANT.HALF_SIZE.id)}
            baseCalories={item?.calories}
            isSize={props.isSize}
            setIsSize={props.setIsSize}
          />
        )}
        {item.full_brink_item_id &&
          (
            <SizeCard
              title={isItMobile ? itemSizeForMobile('FULL', item?.category_name, item?.category_id) : itemSizeForDesktop('FULL', item?.category_name, item?.category_id)}
              id={CONSTANT.FULL_SIZE.id}
              calories={getItemTotalCalories(item.full_calories || 0)}
              price={getItemTotal(item, order, item.price, CONSTANT.LARGE_SIZE.id)}
              additionalPrice={order?.display_price}
              onChange={handleItemSizeChange}
              selected={order.size === CONSTANT.LARGE_SIZE.id || reward_size?.toUpperCase() === CONSTANT.LARGE_SIZE.id}
              handleRedeemSize={handleRedeemSize}
              disabled={Boolean(reward_size && reward_size?.toUpperCase() !== CONSTANT.LARGE_SIZE.id)}
              baseCalories={item?.full_calories}
              isSize={props.isSize}
              setIsSize={props.setIsSize}
            />
          )}
      </div>
    </React.Fragment>
  );
};

export default ItemSizeCard;
